import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { matchPath } from 'react-router';

import { topicQuery } from 'core/queries/topic';

import useRequest from 'core/hooks/useRequest';
import { EMPTY_OBJECT, VOID_QUERY } from 'core/site/constants';
import {
  topicAmp as topicAmpPattern,
  topic as topicPattern,
} from 'core/components/BaseRoutes/routes-patterns';

import SharedRenderContext from 'core/components/SharedRenderContext';

export const GlobalTopicContext = createContext(EMPTY_OBJECT);


function GlobalTopicProvider(props, context) {
  const { children, location, history } = props;
  const { appStatus } = useContext(SharedRenderContext).routerContext || {};
  const { amp } = context;

  const matchPattern = amp ? topicAmpPattern : topicPattern;
  const match = matchPath(location.pathname, matchPattern);
  // TODO 11158: продумать более универсальный вариант обхода таких ситуаций
  //
  // Если в appStatus что-то есть, значит отрисовка происходит с целью показать
  // страницу ошибки. Если причиной ошибки был именно этот запрос, нода уйдёт в
  // бесконечный цикл. Чтобы этого избежать, не запрашиваем топик при наличии appStatus
  const hookParams = !appStatus && match
    ? topicQuery({ match, location, history })
    : VOID_QUERY;
  const { data: topic } = useRequest(hookParams);

  return (
    <GlobalTopicContext.Provider value={topic}>{children}</GlobalTopicContext.Provider>
  );
}

GlobalTopicProvider.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

GlobalTopicProvider.contextTypes = {
  amp: PropTypes.bool,
};

export default GlobalTopicProvider;
